import en from './en.json';
import fr from './fr.json';

const translations = { en, fr };

// Get language from URL prefix
export function getCurrentLanguage() {
    return window.location.pathname.startsWith('/fr') ? 'fr' : 'en';
}

// Translation function
export function t(key) {
    const lang = getCurrentLanguage();
    return translations[lang][key] || translations['en'][key] || key;
}
